import { Button } from 'antd'
import { useContext } from 'react'
import SegmentContext from '@/components/SegmentHelpers/hooks/createContext'
import { DeleteOutlined } from '@ant-design/icons'
import TagTrigger from '@/components/Tag'
import { imageDataToImage, stickToHighLightMask } from '@/components/SegmentHelpers/maskUtils'
import './index.less'
const StickerArea = () => {
  const {
    image: [image],
    resultMask: [_resultMask, setResultMask],
    resultHighlightMask: [, setResultHighlightMask],
    stickers: [stickers, setStickers],
    isChanging: [, setIsChanging]
  } = useContext(SegmentContext)!

  const handleCutOutDelete = (sticker: any) => {
    const result = stickers.filter((item) => item.img != sticker.img)
    setStickers(result)
    console.log(result)
    if (result.length == 0 && image) {
      const arr = new Uint8ClampedArray(4 * image.width * image.height).fill(0)
      setResultMask(imageDataToImage(new ImageData(arr, image.width, image.height)))
    }
    setIsChanging(true)
  }
  const handleStickerOver = (sticker: any) => {
    if (image) {
      setResultHighlightMask(stickToHighLightMask(sticker, image.width, image.height))
    }
  }
  const handleStickerOut = () => {
    setResultHighlightMask(null)
  }
  const handleClearAll = () => {
    setStickers([])
    setIsChanging(true)
    if (image) {
      const arr = new Uint8ClampedArray(4 * image.width * image.height).fill(0)
      setResultMask(imageDataToImage(new ImageData(arr, image.width, image.height)))
    }
    setResultHighlightMask(null)
  }
  return (
    <div className='cut-row'>
      <div className='title-row'>
        <h4>标注列表</h4>
        <Button
          size='small'
          className='cut-button'
          onClick={handleClearAll}
          disabled={stickers.length === 0 ? true : false}
        >
          清空
        </Button>
      </div>
      <div className='cut-container'>
        {stickers.map((sticker: any, i: number) => (
          <div key={i} className='sticker-container'>
            <Button
              size='small'
              icon={<DeleteOutlined />}
              className='cut-button'
              onClick={() => handleCutOutDelete(sticker)}
            />
            <div className='sticker-img-container'>
              <img
                key={i}
                className='sticker-img'
                src={sticker.img.src}
                onMouseOver={() => handleStickerOver(sticker)}
                onMouseOut={handleStickerOut}
              />
            </div>
            <div className='tag'>
              <TagTrigger tagIndex={i} name={stickers[i].name} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
export default StickerArea
